import React from 'react';
import _ from 'lodash';
import { styled } from 'styled-components';
import { Box, Step, StepLabel, Stepper } from '@mui/material';

const StepperStyleComponent = styled.div`

        .main_stepperRoot {
            /* max-width: 332px; */
            margin: 40px auto 60px;
            display: flex;
            justify-content: space-between;
            gap:15px;
            @media (max-width:767px){
                margin: 20px auto 20px;
            }
        }

        .step_CustomRoot {
            max-width: 345px;
            padding: 0;
            ${'' /* margin-bottom: 16px; */}
            @media (max-width:1535px){

            }
            .MuiStepConnector-root {
                width: 100%;
                left: calc(-50% - 20px);
                top: 20px;
                z-index: 1;
                @media (max-width:575px){
                    left: calc(-50% - 10px);
                }
                .MuiStepConnector-line {
                    border-top-width: 2px;
                    border-color: #444444;
                }
            }

            .stepLable_Root {
                position: relative;
                z-index: 2;
                .stepLabelContainer {
                    .stepLabel_label {
                        font-weight: 400;
                        font-size: 16px;
                        line-height: 1.2;
                        text-align: center;
                        letter-spacing: 2px;
                        text-transform: uppercase;
                        color: #444;
                        @media (max-width:575px){
                            font-size: 12px;
                        }
                    }
                }
                .MuiStepLabel-iconContainer {
                    height: 42px;
                    width: 42px;
                    @media (max-width:575px){
                        height: 39px;
                        width: 39px;
                        }

                    svg {
                        height: 100%;
                        width: 100%;
                        fill: #fff;
                        transition: all ease-in-out 0.3s;
                        background-color: #fff;
                        border: 2px solid #000;
                        z-index: 2;
                        position: relative;
                        border-radius: 50px;


                        .MuiStepIcon-text {
                            font-size: 0px;
                            line-height: 1;
                            font-weight: 500;
                            fill: #6B6C6F;
                            font-family: 'Open Sans', sans-serif;
                        }
                    }
                    &.Mui-active{ 
                        svg {
                        fill: #444444;
                        border-color: #444444;
                        border: 2px solid #444444;
                        background-color: #444;
                        }
                    }
                    &.Mui-completed {
                        svg.Mui-completed {
                        background: #ffffff;
                        fill: #ffffff;
                        border: 2px solid #000000;
                    }
                }

                }
            }

        }
    
    .step_CustomRoot.completedStep .MuiStepLabel-iconContainer svg,
    .stepper-wrap .step_CustomRoot.completedStep+.step_CustomRoot .MuiStepLabel-iconContainer svg {
        fill: #444444;
        background-color: #fff;
    }

   .step_CustomRoot.completedStep .MuiStepLabel-iconContainer svg .MuiStepIcon-text,
    .stepper-wrap .step_CustomRoot.completedStep+.step_CustomRoot .MuiStepLabel-iconContainer svg .MuiStepIcon-text {
        fill: #fff;
    }


    .stepper_container{
        h3, h1 {
        font-weight: 700;
        font-size: 28px;
        line-height: 28px;
        text-align: center;
        letter-spacing: 4px;
        color: #000;
        font-family: 'Futura Cyrillic Book' !important;
        text-transform: uppercase;
        @media (max-width:767px){
            font-size: 22px;
        }
        }
    } 

    .ambester_products{
        h3 {
        font-size: 24px; 
        letter-spacing: 0;
        text-align: left;
        text-transform: capitalize;
        @media (max-width:767px){
            font-size: 20px;
        }
        }   
        }
    }
    .no_thaks_btn {
    font-size: 16px;
    color: #444;
    padding-top:18px;
}
`;

const StepperComponent = ({
    children,
    steps,
    activeStep,
}) => {
    return (
        <StepperStyleComponent>
            <Box sx={{ margin: 'auto' }} >
                <Stepper activeStep={activeStep} alternativeLabel classes={{ root: "main_stepperRoot !mb-8" }}>
                    {_.map(steps, (label) => (
                        <Step key={label} classes={{ root: "step_CustomRoot", completed: "completedStep" }}>
                            <StepLabel classes={{ root: "stepLable_Root", labelContainer: 'stepLabelContainer', label: "stepLabel_label" }}>{label}</StepLabel>
                        </Step>
                    ))}
                </Stepper>
                <div className='stepper_container'>
                    {children}
                </div>
            </Box>
        </StepperStyleComponent>
    );
};

export default StepperComponent;